import React from 'react';
import styled from 'styled-components/native';
import StudyParticipantCard from '../study/cards/StudyParticipantCard';
import { addDays } from 'date-fns';
import Chip from '../../components/Chip';
import { log } from '../../tools/LogHelper';
import { StudyParticipant } from '../../models/StudyParticipant';

const StyledView = styled.View`
  flex: 1;
  align-items: center;
  justify-content: center;
  background-color: white;
`;

const ExampleStudyCardScreen: React.FC = () => {
  const accessory = (
    <Chip size='small' color='#ccf5ff'>
      Clinical
    </Chip>
  );

  const mockData = {
    imageUrl:
      'https://drive.google.com/uc?id=1yu2LAbdPkH34iqvsOP4XMlwERmGqn4Wj',
    backgroundColor: '#000'
  };

  const mockStudyParticipant = {
    id: -1,
    studyId: -1,
    userId: -1,
    startDate: addDays(new Date(), -12),
    studyLength: 25,
    participantEvents: [],
    study: {
      id: -1,
      name: 'CBD Sleep Study',
      studyLength: 25
    }
  } as unknown as StudyParticipant;

  return (
    <StyledView>
      <StudyParticipantCard
        studyParticipant={mockStudyParticipant}
        imageUrl={mockData.imageUrl}
        backgroundColor={mockData.backgroundColor}
        accessory={accessory}
        onFavorite={() => {
          log('Favorite Pressed');
        }}
        onShare={() => {
          log('Share Pressed');
        }}
      />
    </StyledView>
  );
};

export default ExampleStudyCardScreen;
